import { TableComponent as Table, ButtonComponent as Button } from '../../components'
import { ReactComponent as iconEye } from '../../assets/img/eye.svg'
import { Tag } from 'antd'
import { formatCronLabel } from '../../utils/cronSchedule'

const AutomacoesTable = ({ automacoes, loading, onView }) => {
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '8%',
            sorter: { compare: (a, b) => a.id - b.id, multiple: 1 }
        },
        {
            title: 'Produto',
            key: 'produto',
            align: 'center',
            width: '22%',
            render: (_, record) => {
                const product = record.product || {}
                return (
                    <div>
                        <div className="font-bold">{product.title || '-'}</div>
                        <div className="tx-gray">{product.ticker || ''}</div>
                    </div>
                )
            }
        },
        {
            title: 'Tipo Contrato',
            key: 'contract_type',
            align: 'center',
            width: '12%',
            render: (_, record) => record.product?.contract_type ?? '-'
        },
        {
            title: 'Status',
            dataIndex: 'enabled',
            key: 'enabled',
            align: 'center',
            width: '12%',
            render: (enabled) => (
                <Tag color={enabled ? 'green' : 'default'}>
                    {enabled ? 'Ativa' : 'Inativa'}
                </Tag>
            )
        },
        {
            title: 'Horário',
            dataIndex: 'horario_cron',
            key: 'horario_cron',
            align: 'center',
            width: '18%',
            render: (cron) => formatCronLabel(cron)
        },
        {
            title: 'Cotação',
            key: 'cotacao',
            align: 'center',
            width: '12%',
            render: (_, record) => {
                if (record.modo_cotacao === 'fixa') {
                    return `Fixa (${record.cotacao_fixa ?? '-'})`
                }
                return 'API'
            }
        },
        {
            title: '% diário',
            dataIndex: 'percentual_diario',
            key: 'percentual_diario',
            align: 'center',
            width: '10%',
            render: (value) => (value != null && Number(value) > 0 ? `${Number(value)}%` : '-')
        },
        {
            title: 'Ações',
            key: 'actions',
            align: 'center',
            width: '12%',
            render: (_, record) => (
                <div style={{ width: 140, margin: '0 auto' }}>
                    <Button
                        type="action"
                        icon={iconEye}
                        htmlType="button"
                        onClick={(e) => {
                            e.stopPropagation()
                            onView(record.id)
                        }}
                    >
                        Detalhes
                    </Button>
                </div>
            )
        }
    ]

    return (
        <Table
            loading={loading}
            column={columns}
            data={automacoes}
            layout="fixed"
            id="automacoes"
        />
    )
}

export default AutomacoesTable
